import cn from 'classnames'
import React from 'react'

//
import { SiteDataContext } from '../../components'
import Image from 'next/image'
import Icon from '../IconNew/Icon'
import { NavLink } from '../helpers'

const MenuList = ({ title = '', items = [], classes }) => {
  const { isTextRtl } = React.useContext(SiteDataContext)

  const getImage = (item) => {
    return item.image ?? item.logo ?? null
  }

  return (
    <div className={cn('c-menu-list', classes, { 'c-menu-list--rtl': isTextRtl })}>
      {title && <div className={'c-menu-list__title'}>{title}</div>}

      <ul className="c-menu-list__list">
        {items.map((item) => {
          if (item.image && item.background) {
            return (
              <li key={item.id}>
                {item.label && (
                  <div className={cn('c-menu-list__title--product')}>{item.label}</div>
                )}
                {item.subtext && <p className="c-menu-list__description">{item.subtext}</p>}
              </li>
            )
          }

          let assetToDisplay = null

          const img = getImage(item)
          if (img) {
            assetToDisplay = (
              <div className="c-menu-list__item-logo">
                <Image src={img?.url} width={28} height={28} alt={`${item.label} logo`} />
              </div>
            )
          } else if (item.icon) {
            assetToDisplay = (
              <div>
                <Icon name={item.icon} classes={'c-menu-list__item-icon'} />
              </div>
            )
          }
          return (
            <li key={item.id}>
              <NavLink to={item.url} className="c-menu-list__item navlink">
                {assetToDisplay}
                <div>
                  <div className="c-menu-list__item-title">{item.label}</div>
                  {item.subtext ? (
                    <div className="c-menu-list__item-subtext">{item.subtext}</div>
                  ) : null}
                </div>
              </NavLink>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default MenuList
